module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "textcentera"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm06"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('strong', [_vm._v("The intensity of the longing is what does all the work.")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "textcenter1"
  }, [_c('strong', [_vm._v("—Rumi, translation by Robert Bly")])]), _vm._v(" "), _c('p', {
    staticClass: "images1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f00vii-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('strong', [_vm._v("Had I been a man I might have explored the Poles or climbed"), _c('br'), _vm._v("Mount Everest, but as it was my spirit found outlet in the air. …")])])]), _c('p', {
    staticClass: "textcenter1"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('strong', [_vm._v("—Amy Johnson, British aviatrix,")]), _vm._v(" "), _c('em', [_vm._v("Myself When Young")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-323d3a79","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm06.vue
// module id = 84
// module chunks = 0